import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const RejectPapModal = ({
	setShowRejectPapModal,
	showRejectPapModal,
	setMessageValue,
	rejectPap,
	postMessage,
	cas,
	setShowPap,
	showPap,
	changeStatus,
	messageValue
}) => {

	useEffect(() => {
		if (cas.state === 100 || cas.state < 4) {
			setShowPap(false);
		}
	}, [showPap]);

	const handleRejection = (e) => {
		e.preventDefault();
		messageValue ? postMessage() : null;
		changeStatus(100, cas.id);

		setMessageValue("");
		// Ferme la modal
		setShowRejectPapModal(false);
		// Fait disparaître la bulle pap dans la messagerie
		setShowPap(false);
		// Update du status en BDD sur 100
		rejectPap();
	};

	const handleCancel = () => {
		// Ferme la modal et reset l'input des messages
		setMessageValue("");
		setShowRejectPapModal(false);
	};

	return (
		<>
			<div className="content">
				<p className="title">Confirmation</p>
				<div className="container-modal">
					<p className="subtitle" >Êtes-vous sûr de vouloir refuser ce plan d&apos;aide personnalisé ? <br/>
						Donnez nous les raisons de votre refus : <br/>
						<textarea className="rejectInput" type="text" onChange={(e) => setMessageValue(e.target.value, cas.id)}/>
					</p>
				</div>
				<form action="" >
					<div className="containerButton">
						<button className="buttonModalPap orange" onClick={handleRejection}>Oui, je confirme</button>
						<button className="buttonModalPap white" onClick={handleCancel}>Annuler</button>
					</div>
				</form>
			</div>
			<div className="modalBackground" onClick={() => showRejectPapModal ? setShowRejectPapModal(false) : null}  ></div>
		</>
	);
};

RejectPapModal.propTypes = {
	setShowRejectPapModal: PropTypes.func,
	showRejectPapModal: PropTypes.bool,
	rejectPap: PropTypes.func,
	setMessageValue: PropTypes.func,
	postMessage: PropTypes.func,
	setShowPap: PropTypes.func,
	changeStatus: PropTypes.func,
	showPap: PropTypes.bool,
	cas: PropTypes.object,
	messageValue: PropTypes.string,
};

export default RejectPapModal;
